import { render } from "./AdminActivities.vue?vue&type=template&id=b6bec67c"
import script from "./AdminActivities.vue?vue&type=script&lang=js"
export * from "./AdminActivities.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__